export const GET_SECURITY_GATE_REQUEST = 'GET_SECURITY_GATE_REQUEST' as const;
export const GET_SECURITY_GATE_SUCCESS = 'GET_SECURITY_GATE_SUCCESS' as const;
export const GET_SECURITY_GATE_ERROR = 'GET_SECURITY_GATE_ERROR' as const;

export const GET_PERIPHERALS_REQUEST = 'GET_PERIPHERALS_REQUEST' as const;
export const GET_PERIPHERALS_SUCCESS = 'GET_PERIPHERALS_SUCCESS' as const;
export const GET_PERIPHERALS_ERROR = 'GET_PERIPHERALS_ERROR' as const;

export const SET_DEP_TITLE = 'SET_DEP_TITLE' as const;
